import { ErrorComponent } from '@/svgs';
import GlobalButton from '@/components/ui/GlobalButton';

const NotFound = () => {
  return (
    <div className="h-screen relative flex mx-auto max-w-7xl overflow-hidden">
      <div className="flex text-white-1 w-full">
        <div className="flex flex-col lg:flex-row items-center gap-4 w-full">
          <div className="my-8 lg:my-0 w-2/3 lg:w-full">
            <ErrorComponent />
          </div>
          <div className="w-full flex flex-col items-center lg:items-start px-5 lg:px-0">
            <h1 className="font-bold text-2xl font-hk tracking-tight">
              We ran into a problem loading this page
            </h1>
            <p className="text-text-primary-body mt-4 max-w-lg text-center lg:text-left">
              We weren’t able to complete your request due to an unexpected
              issue. Your work is safe, and nothing has been lost
            </p>
            <div className="w-fit min-w-44 mt-10">
              <GlobalButton variant="purpleStroke" to={'/'}>
                Go back
              </GlobalButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
